(() => {
  if (window.__sanounKlaviyoCartTracking) return;
  window.__sanounKlaviyoCartTracking = true;

  const originalFetch = window.fetch.bind(window);
  const absoluteUrl = (value) => {
    if (!value) return '';
    return new URL(value, window.location.origin).href;
  };

  const trackAddedToCart = async (addResponse) => {
    const addedItems = Array.isArray(addResponse.items) ? addResponse.items : [addResponse];
    const validItems = addedItems.filter((item) => item && item.id && !item.status);
    if (!validItems.length) return;

    let cart = null;
    try {
      const cartResponse = await originalFetch(`${window.Shopify.routes.root}cart.js`, {
        credentials: 'same-origin',
      });
      if (cartResponse.ok) cart = await cartResponse.json();
    } catch (error) {
      console.warn('Sanoun cart tracking could not read the cart.', error);
    }

    const firstItem = validItems[0];
    const itemNames = cart && Array.isArray(cart.items)
      ? cart.items.map((item) => item.product_title || item.title)
      : validItems.map((item) => item.product_title || item.title);
    const eventItems = validItems.map((item) => ({
      ProductID: item.product_id,
      VariantID: item.variant_id || item.id,
      ProductName: item.product_title || item.title,
      VariantName: item.variant_title || '',
      SKU: item.sku || '',
      Quantity: item.quantity || 1,
      ItemPrice: Number(item.final_price || item.price || 0) / 100,
      RowTotal: Number(item.final_line_price || item.line_price || item.price || 0) / 100,
      ImageURL: absoluteUrl(item.featured_image && item.featured_image.url ? item.featured_image.url : item.image),
      ProductURL: absoluteUrl(item.url),
    }));

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', {
      $value: cart ? Number(cart.total_price || 0) / 100 : eventItems.reduce((sum, item) => sum + item.RowTotal, 0),
      AddedItemProductName: firstItem.product_title || firstItem.title,
      AddedItemProductID: firstItem.product_id,
      AddedItemVariantID: firstItem.variant_id || firstItem.id,
      AddedItemSKU: firstItem.sku || '',
      AddedItemImageURL: absoluteUrl(firstItem.featured_image && firstItem.featured_image.url ? firstItem.featured_image.url : firstItem.image),
      AddedItemURL: absoluteUrl(firstItem.url),
      AddedItemPrice: Number(firstItem.final_price || firstItem.price || 0) / 100,
      AddedItemQuantity: firstItem.quantity || 1,
      ItemNames: itemNames,
      Items: eventItems,
      CartURL: absoluteUrl(window.Shopify.routes.root + 'cart'),
      CheckoutURL: absoluteUrl(window.Shopify.routes.root + 'checkout'),
    }]);
  };

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const requestUrl = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    if (requestUrl && requestUrl.includes('/cart/add') && response.ok) {
      response.clone().json().then(trackAddedToCart).catch(() => {});
    }
    return response;
  };
})();
